import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Products API
export const getProducts = async () => {
  const response = await api.get('/products');
  return response.data;
};

export const getProductsByCategory = async (category) => {
  const response = await api.get(`/products/${category}`);
  return response.data;
};

export const getProductById = async (category, productId) => {
  const response = await api.get(`/products/${category}/${productId}`);
  return response.data;
};

// RFQ API
export const submitRFQ = async (rfqData) => {
  const response = await api.post('/rfq', rfqData);
  return response.data;
};

// Contact API
export const submitContact = async (contactData) => {
  const response = await api.post('/contact', contactData);
  return response.data;
};

// Engineering Services API
export const getServices = async () => {
  const response = await api.get('/services');
  return response.data;
};

export const submitServiceInquiry = async (inquiryData) => {
  const response = await api.post('/services/inquiry', inquiryData);
  return response.data;
};

export default api;
